module.exports = __webpack_public_path__ + "img/旋转2.e7ac6a2a.svg";